/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileEdit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M19.998 7.586V10h-2V9h-5V4h-7v16h4v2h-6V2h10.414zm-5-.586h1.586l-1.586-1.586z" />
        <path d="M17.291 12.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414L16.412 22h-4.414v-4.414zm-3.293 6.121V20h1.586l4-4-1.586-1.586zM10 17H8v-2h2zm0-4H8v-2h2zm4 0h-3v-2h3zm-4-4H8V7h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileEdit as FileEdit };
